<template>
    <div class="outer-wrapper">
    <div class="page-header clear-filter">
    </div>
    <div class="ls section form_position">
       <div class="container">
            <div class="row align-items-center">
          	    <div class="col-sm-12" >
          	        <div class="text-center">
                        <div class="page-404 text-center">
								<p class="page-404__title text-center">404</p>
								<p class="page-404__text text-center">Oops, page not found!</p>
								<a href="/" class="button-o_t2">Back To Home</a>
							</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scope>
.my-auto{margin-top: auto;
margin-bottom: auto; padding-right:35px; padding-left:35px;}
</style>